import TmLogo from "@assets/tm_logo.webp";
import { ReactElement } from "react";
import { Link } from "react-router";

// Footer Component
const TmBanner = (): ReactElement => {
  return (
    <div className="bg-pink-1000 pt-8 max-w-6xl mx-auto px-4 text-center lg:mb-24">
      <Link to="/" target="_blank" rel="noreferrer" reloadDocument>
        <p className="text-md leading-[120%] font-bold font-serif text-pink-500 mb-4">
          Catch up on the latest Tamil news with
        </p>

        <img
          width={297.5}
          height={68}
          alt="Home"
          src={TmLogo}
          className="inline py-3"
        />
      </Link>
    </div>
  );
};

export default TmBanner;
